export function setMetaTagColor(color: string) {
    const metaTag = document.querySelector(`meta[name="theme-color"]`);
    if (metaTag) {
        //@ts-expect-error
        metaTag.content = color;
    } else {
        // Handle missing meta tag, e.g., create a new one
        const newMetaTag = document.createElement('meta');
        newMetaTag.name = "theme-color"
        newMetaTag.content = color;
        document.head.appendChild(newMetaTag);
    }
}